<app-navbar
  [isMobileOpen]="dropdownMenu"
  (menuSizeChanged)="onMenuSizeChanged($event)"
  (mobileMenuClosed)="onMenuItemSelected()"
/>

<div class="content-shell">
  <app-header
    headerId="horizontal-nav"
    variant="shell"
    title="OrgLines"
    [subtitle]="'ORGLINES_SUBTITLE' | translate"
    [showMenuButton]="true"
    [showProfileInfo]="true"
    [showProfileDetails]="false"
    imageWidth="35px"
    imageHeight="35px"
    (menuToggle)="toggleMenu()"
  />
  <main appAiAssistantWidget class="main-content" [class.menu-minimized]="isMinimizedMenu">
    <div class="main-content-inner" [class.main-content-inner--support-mode]="isSupportModeVisible">
      @if (isForbidden$ | async) {
        <app-forbidden />
      } @else {
        <router-outlet />
      }
    </div>
  </main>

  @if (isSupportModeVisible) {
    <div class="support-mode-banner-shell" [class.menu-minimized]="isMinimizedMenu">
      <section class="support-mode-banner" [class.support-mode-banner--loading]="isSupportModeLoading">
        <p class="support-mode-banner__text">
          <span class="support-mode-banner__label">
            {{ "COMPONENTS.COMPANIES.SUPPORT_MODE_LABEL" | translate }}:
          </span>
          <span class="support-mode-banner__mode">
            {{ supportModeAccessLabelKey | translate }}
          </span>
          <span class="support-mode-banner__company">({{ supportModeCompanyName }})</span>
        </p>
        <button
          type="button"
          class="support-mode-banner__action"
          [disabled]="isSupportModeLoading"
          (click)="leaveSupportMode()"
        >
          {{ "COMPONENTS.COMPANIES.LEAVE_SUPPORT_MODE" | translate }}
        </button>
      </section>
    </div>
  }
</div>
